import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

// hooks
import useCompanySuspended from 'core/hooks/useCompanySuspended';

interface CheckSuspendedProps {
	redirectTo: string;
	children: ReactNode;
}

/**
 * Guards the pages that update a record. A generally suspended company is sent back to the list it
 * came from, so the page cannot be reached by typing its url either.
 */
export const CheckSuspended = ({ redirectTo, children }: CheckSuspendedProps): JSX.Element => {
	const { isGeneralSuspended } = useCompanySuspended();

	if (isGeneralSuspended) {
		return <Navigate to={redirectTo} replace />;
	}

	return <>{children}</>;
};
